module.exports = __webpack_public_path__ + "img/8.3ddd7125.jpg";